import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useQueryParam, StringParam } from "use-query-params";
import { useMediaQuery } from "react-responsive";
import { useDispatch } from "react-redux";
import { setSelectedMarker } from "../../../reducers/mapReducer";

export const useListingsMap = ({ listings }) => {
    const dispatch = useDispatch();
    const [hoveredListing, setHoveredListing] = useState(null);
    const [view, setView] = useQueryParam("agentOverlay", StringParam);
    const activeMarker = useSelector((state) => state.map.activeMarker);
    const isTouchDevice = useSelector((state) => state.root.isMobile);
    const isTablet = useMediaQuery({ maxWidth: 992, minWidth: 768 });
    const isMedium = useMediaQuery({ maxWidth: 768, minWidth: 576 });
    const isSmall = useMediaQuery({ maxWidth: 576 });
    const isMobileOrTablet = isTouchDevice || isTablet || isMedium || isSmall;
    const selectedMarker = useSelector((state) => state.map.selectedMarker);
    const bottomOffset = selectedMarker ? "65px" : 0;

    const currentView = view || "preview";
    const isFullscreen = currentView !== "preview";
    const isMapView = currentView === "map";
    const isListView = currentView === "list";

    useEffect(() => {
        if (!isMapView) {
            dispatch(setSelectedMarker(undefined));
        }
    }, [isMapView, dispatch]);

    const markers = listings
        ?.map((marker) => {
            if (!marker?.latitude || !marker?.longitude) {
                return null;
            }
            return {
                id: marker?.listingId,
                lat: marker?.latitude,
                lng: marker?.longitude,
                isActive:
                    activeMarker === marker?.listingId ||
                    hoveredListing === marker?.listingId,
                listingId: marker?.listingId,
                type: "listing",
                click: {
                    path: marker?.urlPath,
                    state: { listingId: marker?.listingId },
                },
                dIListingPreview: {
                    image: marker?.image,
                    price: marker?.price,
                    bedrooms: marker?.bedrooms,
                    bathrooms: marker?.bathrooms,
                },
            };
        })
        .filter((marker) => marker !== null);

    // Create preview listings array with View All button for mobile
    const previewListings = isMobileOrTablet
        ? [
              ...listings.slice(0, 9),
              {
                  listingId: "view-all",
                  onClick: () => setView("list"),
                  viewAllButton: true,
              },
          ]
        : listings;

    return {
        setView,
        setHoveredListing,
        isFullscreen,
        isMapView,
        isListView,
        markers,
        previewListings,
        bottomOffset,
        isTablet,
        isMedium,
        isSmall,
    };
};
